const TasksIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.69654 12.2715H6.66478C6.24564 12.2715 5.90625 12.6109 5.90625 13.03C5.90625 13.4492 6.24564 13.7886 6.66478 13.7886H9.69654C10.1157 13.7886 10.4551 13.4492 10.4551 13.03C10.4551 12.6109 10.1157 12.2715 9.69654 12.2715Z"
        className="fill-color"
      />
      <path
        d="M12.7258 8.4834H6.66478C6.24564 8.4834 5.90625 8.82279 5.90625 9.24193C5.90625 9.66108 6.24564 10.0005 6.66478 10.0005H12.7258C13.1449 10.0005 13.4843 9.66108 13.4843 9.24193C13.4843 8.82279 13.1449 8.4834 12.7258 8.4834Z"
        className="fill-color"
      />
      <path
        d="M16.0047 3.67679C15.4195 3.0916 14.6756 2.89546 13.6445 2.8271C13.3026 2.13936 12.5962 1.6665 11.7799 1.6665H7.61277C6.79563 1.6665 6.08756 2.1418 5.74817 2.8271C4.71455 2.89546 3.9731 3.0916 3.38794 3.67679C2.5 4.56473 2.5 5.81887 2.5 8.09618V13.0258C2.5 15.3031 2.5 16.5572 3.38794 17.4452C4.27588 18.3332 5.52774 18.3332 7.80317 18.3332H11.591C13.8667 18.3332 15.1185 18.3332 16.0063 17.4452C16.8942 16.5573 16.8942 15.3031 16.8942 13.0258V8.09618C16.8942 5.81887 16.8942 4.56479 16.0063 3.67679H16.0047ZM7.61032 3.17869H11.7774C12.0899 3.17869 12.3463 3.43264 12.3463 3.74761C12.3463 4.06257 12.0899 4.31652 11.7774 4.31652H7.61032C7.29779 4.31652 7.04141 4.06257 7.04141 3.74761C7.04141 3.43264 7.29779 3.17869 7.61032 3.17869ZM15.3757 13.0259C15.3757 15.0387 15.3569 15.947 14.9321 16.3742C14.5048 16.8015 13.599 16.8177 11.5878 16.8177H7.79994C5.78966 16.8177 4.88048 16.799 4.45565 16.3742C4.02836 15.9469 4.01209 15.041 4.01209 13.0259V8.09626C4.01209 6.08352 4.03081 5.17514 4.45565 4.74802C4.67051 4.53152 5.00177 4.41432 5.61624 4.35654C5.87669 5.21113 6.67022 5.83129 7.60782 5.83129H11.7749C12.7125 5.83129 13.506 5.20867 13.7665 4.35654C14.3834 4.41514 14.7122 4.53152 14.9287 4.74802C15.356 5.17531 15.3722 6.08115 15.3722 8.09626V13.0259H15.3757Z"
        className="fill-color"
      />
    </svg>
  );
};

export default TasksIcon;
